module.exports = __webpack_public_path__ + "media/images/app/mail-f33d56d6bdc3fc60e679f8ebe765968a.svg";